import type { Map } from '@gonfalon/immutable-shim/immutableShim';

import { type Repository } from './records/Repository';

export function applyCodeReferenceRepoFilter(repos: Map<string, Repository>, repoFilter: string) {
  return repoFilter ? repos.filter((r) => r.id === repoFilter) : repos;
}
